import styled, { css } from 'styled-components';

interface ButtonProps {
  buttonColor: string;
}

interface MenuContentProps {
  isMenuOpen: boolean;
}

interface HeaderProps {
  headerColor: string;
  counterColor: string;
  isWordle?: boolean;
}

export const ItemColor: { [key: string]: string } = {
  green: 'green',
  purple: 'purple',
};

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;
  padding: 0;
  min-height: 13.25vh;

  @media (max-width: 996px) {
    min-height: 20vh;
  }
`;

export const DesktopHeader = styled.div`
  display: flex;
  width: 100%;

  @media (max-width: 996px) {
    display: none;
  }
`;

export const MobileHeader = styled.div`
  width: 100%;
  @media (min-width: 997px) {
    display: none;
  }
`;

export const MidContent = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  align-items: center;
  cursor: pointer;

  img {
    height: 12.5vh;
    /* width: 5.9vw; */
    width: auto;
  }

  svg {
    color: ${({ theme }) => theme.icon};
  }
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 0 1rem;

  width: 10.5vw;

  svg {
    color: ${({ theme }) => theme.icon};
  }
`;

export const Button = styled.button<ButtonProps>`
  padding: 0.2rem 0.5rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, buttonColor }) =>
    buttonColor === 'purple' ? theme.purple : theme.green};

  :hover {
    filter: brightness(1.1);
  }

  p {
    color: ${({ theme }) => theme.white};
    font-weight: bold;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
    margin: 0;
  }

  svg {
    color: ${({ theme }) => theme.white};
    margin-left: 0.5rem;
  }
`;

export const Header = styled.header<HeaderProps>`
  color: #fff;

  > p {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 9vh;
    background: ${(props) => props.headerColor};

    font-size: 2rem;
    text-align: center;
    margin: 0;

    img {
      margin-right: 12px;
      width: 2rem;
    }

    @media (min-width: 540px) {
      font-size: 3rem;

      img {
        width: 3rem;
      }
    }
  }

  ${(props) =>
    props.isWordle &&
    css`
      > p {
        color: #000;

        img {
          background: #000;
        }
      }
    `}

  span {
    display: flex;
    align-items: center;
    width: 100%;
    background-color: ${(props) => props.counterColor};

    justify-content: space-around;
    font-size: 1rem;
    height: 5rem;

    > svg {
      transform: rotate(270deg);
      height: 1rem;
      cursor: pointer;
    }

    p {
      color: #fff;
      display: flex;
      align-items: center;
      margin: 0;

      svg {
        margin-right: 8px;
      }
    }
  }
`;

export const MenuContent = styled.div<MenuContentProps>`
  transform-origin: top;
  transition: 0.3s ease-in;

  ${({ isMenuOpen }) =>
    isMenuOpen
      ? css`
          transform: rotateX(0deg);
        `
      : css`
          transform: rotateX(-90deg);
        `}
`;
